export function getParsedLocalStorage(key, _defaultValue) {
  const data = localStorage.getItem(key);
  if (!data) return _defaultValue ?? null;
  return JSON.parse(data);
}
export function getLocalStorage(key, _defaultValue) {
  return localStorage.getItem(key) ?? _defaultValue ?? null;
}
